/* eslint-disable react/forbid-prop-types */
import 'url-search-params-polyfill';

import React, { useState } from 'react';
// useState
import { Tabs, Button } from 'antd';

import PricingTab from '../../../components/DibbsTabs/pricingTab';

// import PropTypes from 'prop-types';

// import { Select, Form, Input, Radio, DatePicker } from 'antd';
// import moment from 'moment';
// import NumberFormat from 'react-number-format';

// import {
//   DownloadOutlined,
//   RightOutlined,
//   LeftOutlined,
// } from '@ant-design/icons';
// // import { Document, Outline, Page } from 'react-pdf';
// import fiftyStates from '../../../config/fiftyStates_copy.json';
// import providence from '../../../config/candianProvinces.json';
// import discountCodes from '../optionsJson/discountCodes.json';

const { TabPane } = Tabs;

const Header = block => {
  const { data } = block;
  console.log(data);

  const [activeKey, setActiveKey] = useState('0');

  const onTabChange = newKey => {
    if (newKey) setActiveKey(newKey);
  };
  const onButtonClick = (forward, location) => {
    let change = 0;
    if (forward) {
      change = 1;
    } else {
      change = -1;
    }
    const activeNum = Number(activeKey) + change;
    console.log(location);
    console.log(data.values[activeNum]);
    if (data.values[activeNum]) {
      setActiveKey(activeNum.toString());
    } else {
      data.changeMenus(location);
    }
  };

  const tabBuilder = () =>
    data.values.map((value, index) => (
      <TabPane tab={`Line ${value.solLnNum}`} key={index}>
        <PricingTab
          values={value}
          changeValues={(key, value1) => {
            data.changeValues(key, value1, index);
          }}
          quoteValues={data.quoteValues}
          changeQuoteValues={data.changeQuoteValues}
          priceBreakValues={data.priceBreakValues}
          changePriceBreaks={data.changePriceBreaks}
          addPriceBreaksToPricing={data.addPriceBreaksToPricing}
          addLinePriceBreaks={data.addLinePriceBreaks}
          reRender={data.reRender}
        />
      </TabPane>
    ));

  return (
    <div className="subcomponent-wrapper">
      <div className="subcomponent-header">Pricing</div>
      <div className="subcomponent-subheader">Pricing & Delivery</div>
      <Tabs activeKey={activeKey} onChange={onTabChange}>
        {tabBuilder()}
      </Tabs>
      <div className="wizard-button-wrapper">
        <Button
          onClick={() => {
            onButtonClick(false, 'contract');
          }}
        >
          Previous
        </Button>
        <Button
          onClick={() => {
            onButtonClick(true, 'priceBreaks');
          }}
          type="primary"
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/pages/DibbsRfq/subcomponents/DibbsPricing.jsx